import { FooterSection, Header } from './sections';
import './sections/style.css';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import SEO from '../../components/common/SEO';
import {breadcrumbSchema} from '../../utils/structuredData';

const TermsOfService = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'production') {
      ReactGA.initialize('G-ZB9N7T58NE');
      ReactGA.send({ hitType: 'pageview', page: '/terms-of-service', title: 'Terms of Service Page' });
    }
  }, []);

  const breadcrumbs = breadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Terms of Service', url: '/terms-of-service' }
  ]);

  return (
    <div className="min-w-full homePageContainer relative !bg-black">
      <SEO
        title="Terms of Service - CadencePro.ai"
        description="Read CadencePro's terms of service to understand the rules, guidelines, and legal agreements for using our platform."
        canonical="/terms-of-service"
        keywords="cadencepro terms of service, legal agreement, user terms, platform rules"
        structuredData={breadcrumbs}
      />
      <Header />
      <main className="w-full flex justify-center px-6 py-12 md:px-12 md:py-16 bg-gradient-to-b from-black via-gray-900/30 to-black">
        <div className="pointer-events-none absolute -top-6 left-2 w-72 h-48 opacity-40 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
        <div className="pointer-events-none absolute bottom-[1050px] right-0 w-72 h-48 opacity-30 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
        <div className="pointer-events-none absolute top-16 right-6 w-56 h-40 opacity-25 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
        <div className="pointer-events-none absolute top-[780px] right-6 w-56 h-40 opacity-25 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
        <div className="pointer-events-none absolute top-1/2 -translate-y-1/2 left-6 w-64 h-44 opacity-25 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
        <div className="pointer-events-none absolute bottom-44 left-1/4 w-72 h-52 opacity-20 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />

        <article className="max-w-3xl w-full space-y-10 leading-7 text-gray-300">
          <header className="space-y-4 text-center pb-8 border-b border-gray-800">
            <h1 className="text-3xl md:text-4xl font-bold text-white">CADENCE PRO INC. TERMS OF SERVICE</h1>
          </header>

          <section className="space-y-4">
            <p className="text-gray-300 text-base leading-relaxed">
              Welcome to Cadence Pro. By using our website and services, you agree to comply with and be bound by the following terms and conditions.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-3">1. ACCEPTANCE OF TERMS</h2>
            <p className="text-gray-300 text-base leading-relaxed">
              By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-3">2. USE OF SERVICE</h2>
            <p className="text-gray-300 text-base leading-relaxed">
              You agree to use the Service only for lawful purposes and in accordance with these Terms. You are responsible for maintaining the confidentiality of your account and password.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-3">3. INTELLECTUAL PROPERTY</h2>
            <p className="text-gray-300 text-base leading-relaxed">
              The Service and its original content, features, and functionality are and will remain the exclusive property of Cadence Pro Inc. and its licensors.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-3">4. TERMINATION</h2>
            <p className="text-gray-300 text-base leading-relaxed">
              We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever, including without limitation if you breach the Terms.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-3">5. LIMITATION OF LIABILITY</h2>
            <p className="text-gray-300 text-base leading-relaxed">
              In no event shall Cadence Pro Inc., nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-3">6. CHANGES TO TERMS</h2>
            <p className="text-gray-300 text-base leading-relaxed">
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide at least 30 days' notice before any new terms take effect.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-3">7. CONTACT US</h2>
            <p className="text-gray-300 text-base leading-relaxed">
              If you have any questions about these Terms, please contact us at <a href="mailto:cadenceproinc@gmail.com" className="text-blue-500 hover:text-blue-400 underline">cadenceproinc@gmail.com</a>.
            </p>
          </section>

          <footer className="text-center pt-8 border-t border-gray-800">
            <p className="text-sm text-gray-500">Last Updated: March 17, 2026</p>
          </footer>
        </article>
      </main>
      <FooterSection />
    </div>
  );
};

export default TermsOfService;
